import { s } from './icon.style'
import React from 'react'
import type { IconProps } from '../iconProps'

export const EditNoteIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        viewBox="0 0 24 24"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 13.292V16H10.708L18.6946 8.01333L15.9867 5.30537L8 13.292ZM20.7888 5.91918C21.0704 5.63755 21.0704 5.18261 20.7888 4.90099L19.099 3.21122C18.8174 2.92959 18.3624 2.92959 18.0808 3.21122L16.7593 4.5327L19.4673 7.24066L20.7888 5.91918V5.91918Z"
          fill="black"
          fill-opacity="0.87"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11 3H3V21H21V12H19V19H5V5H11V3Z"
          fill="black"
        />
      </svg>
    )
  }
)
